import * as football from './football';
import * as rugbyLeague from './rugbyLeague';
import * as rugbyUnion from './rugbyUnion';

export const graphicUis = {
  football,
  rugbyLeague,
  rugbyUnion
};
